import { render, staticRenderFns } from "./ForgotPasswordReset.vue?vue&type=template&id=1e93d7ab&scoped=true&"
import script from "./ForgotPasswordReset.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordReset.vue?vue&type=style&index=0&id=1e93d7ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e93d7ab",
  null
  
)

export default component.exports